import React, { useState, useRef } from 'react'
import AsyncSelect from 'react-select/async'
import { components } from 'react-select'

import clearIcon from '../../assets/icons/close-circled.svg'
import searchIcon from '../../assets/icons/search-icon.svg'

// Debounce helper
function debouncePromise(fn, delay) {
  let timeoutId

  return (...args) => {
    clearTimeout(timeoutId)

    return new Promise((resolve) => {
      timeoutId = setTimeout(async () => {
        const result = await fn(...args)
        resolve(result)
      }, delay)
    })
  }
}

// react select control for assign tickets
export default function AsyncSelectControl({
  placeholder,
  noOptionsMessage,
  existingUser,
  defaultUser,
  onChange,
  loadUsers,
  inputRef,
}) {
  const handleKeyDown = (e) => {
    // save input value to ref
    if (e.target.value) inputRef.current = e.target.value
    // tab key is pressed, don't do anything
    if (e.key === 'Tab') e.preventDefault()
  }

  // 👇 This moves the search icon (DropdownIndicator) to the LEFT
  const Control = ({ children, ...props }) => (
    <components.Control {...props}>
      <div style={{ marginLeft: 8 }}>
        <DropdownIndicator {...props} />
      </div>
      {children}
    </components.Control>
  )

  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ display: 'flex' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <div className="select-label one">{props.data.label}</div>
          </div>
          <div className="select-label two">{props.data?.custom}</div>
        </div>
      </components.Option>
    )
  }

  const MultiValueLabel = (props) => {
    const {
      innerProps: { innerRef, ...innerProps },
    } = props

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="react-select__multi-value__label"
      >
        {props.data.chipLabel}
      </div>
    )
  }

  const Menu = (props) => {
    return (
      <components.Menu {...props}>
        <div className="react-select__menu__container">
          <div>{props.children}</div>
        </div>
      </components.Menu>
    )
  }

  const DropdownIndicator = (props) => {
    const {
      innerProps: { innerRef, ...innerProps },
    } = props
    return (
      <img ref={innerRef} {...innerProps} src={searchIcon} alt="search icon" />
    )
  }

  const ClearIndicator = (props) => {
    const {
      innerProps: { innerRef, ...innerProps },
    } = props
    return (
      <img ref={innerRef} {...innerProps} src={clearIcon} alt="clear icon" />
    )
  }

  // Debounced version
  const debouncedLoadUsers = debouncePromise(loadUsers, 400)

  // ✅ Debounced async loader that RETURNS a Promise
  const loadOptions = (inputValue) => {
    // return loadUsers(inputValue);
    return debouncedLoadUsers(inputValue)
  }

  return (
    <div className="select">
      <AsyncSelect
        cacheOptions
        isClearable
        hideSelectedOptions={false}
        loadOptions={loadOptions} // async fetching
        defaultOptions={
          existingUser || defaultUser ? [existingUser || defaultUser] : false
        }
        value={existingUser || null}
        getOptionValue={(option) =>
          option?.value || option?.email || option?.label
        }
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={noOptionsMessage}
        onKeyDown={handleKeyDown}
        maxMenuHeight={200}
        components={{
          Control,
          MultiValueLabel,
          Menu,
          IndicatorSeparator: () => null,
          DropdownIndicator: () => null,
          ClearIndicator,
          Option,
        }}
        styles={{
          control: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            paddingRight: '12px',
            paddingLeft: '12px',
          }),
          indicatorsContainer: (base) => ({
            ...base,
            width: '25px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }),
          option: (baseStyles, { isFocused }) => ({
            ...baseStyles,
            color: '#23262F',
            backgroundColor: isFocused ? '#3e8bf71a' : null,
          }),
        }}
        className="react-select"
        classNamePrefix="react-select"
      />
    </div>
  )
}
